import React from 'react';

import {
	petLossGroupLinkItems,
	petLossSupportGroupsAndResources,
} from '@app/components/Pages/Services/PetLossSupportGroup/PetLossSupportGroupContent';
import LinkBlockSmall from '@app/components/UI/LinkBlock/LinkBlockSmall';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import petLossGroupHeader from '@app/images/content/petLossGroupHeader.jpg';
import '@app/scss/components/ourServices.scss';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';

const PetLossSupportGroup: React.FC = () => {
	return (
		<HelmetProvider>
			<div className="our-services pet-loss-group">
				<Masthead
					title="Pet Loss Support"
					imageSrc={petLossGroupHeader}
					text="Lap of Love Grief Coaches are extremely sensitive and supportive. The empathy is extraordinary as well as the advice."
					quoteAuthor="Nina, Support Group Attendee"
					buttonText={
						<a href="https://petloss.lapoflove.com/" target="_blank" rel="noopener noreferrer">
							<button type="button" className="btn btn-sm btn-primary">
								Learn More
							</button>
						</a>
					}
					imageAlt="Pet loss support"
				/>

				<RichText
					title="Pet Loss Support Groups and Resources"
					text={petLossSupportGroupsAndResources}
				/>

				<LinkBlockSmall items={petLossGroupLinkItems} />
			</div>
		</HelmetProvider>
	);
};

export default PetLossSupportGroup;
